module.exports = __webpack_public_path__ + "media/images/icons/icn_001-73e26f5f767a8a399793edf87207a0b4.svg";